import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AddToCartInput } from 'src/app/@resources/graphql/types/types';
import { InformationToBeSendComponent } from 'src/app/modules/session/information-to-be-send/information-to-be-send.component';
import { CartService } from '../../services/cart/cart.service';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';

@Component({
  selector: 'app-session-item',
  templateUrl: './session-item.component.html',
  styleUrls: ['./session-item.component.scss'],
})
export class SessionItemComponent implements OnInit {
  @Input() name: any;
  @Input() price: any;
  // @Input() salePrice: any;
  @Input() image: any;
  @Input() productId: any;
  @Input() session: any;
  cardId: string =
    localStorage.getItem('amandaCartId') ||
    localStorage.getItem('amandaClientCartId') ||
    '';
  constructor(
    public dialog: MatDialog,
    private cartService: CartService,
    private toastrService: ToastrService,
    private storage: LocalStorageService
  ) {}

  ngOnInit(): void {}

  async openFormDialog() {
    const lang = this.storage.get('lang');
    const { arabic_name, english_name, image, lst_price, name, product_id } =
      this.session;
    const obj: AddToCartInput = {
      arabic_name,
      english_name,
      image,
      lst_price,
      product_id: String(product_id),
      qty: 1,
      offer_code: this.session.default_code,
      cartId: this.cardId,
    };
    obj.branch = localStorage.getItem('branch') || '';
    if (this.cardId === '') {
      const cart = this.cartService.createCart();
      this.cardId =
        localStorage.getItem('amandaClientCartId') ||
        localStorage.getItem('amandaCartId') ||
        cart.cartId;
      obj.cartId = this.cardId;
      this.cartService.addToCart(obj);
      lang == 'en'
        ? this.toastrService.success(`Add item`, `Item added successfully`)
        : this.toastrService.success(`تم اضافة عنصر للسلة`, `اضافة عنصر`);
    } else {
      this.cartService.addToCart(obj);
      lang == 'en'
        ? this.toastrService.success(`Add item`, `Item added successfully`)
        : this.toastrService.success(`تم اضافة عنصر للسلة`, `اضافة عنصر`);
    }

    // const dialogRef = this.dialog.open(InformationToBeSendComponent, {
    //   autoFocus: false,
    //   data: {
    //     offerName: this.name,
    //   },
    // });
  }
}
